import React, {useContext, useEffect, useState} from 'react';
import GenerateURL from "../../utils/generateURL";
import {INDEX_ROUTE} from "../../utils/consts";
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Language from "../Language";

import logo from '../../img/logo.svg'
import Menu from "../Menu";
import {useWindowSize} from "../../hooks/useWindowSize";
import {observer} from "mobx-react-lite";
import {MobileMenuContext} from "../../App";
import {ScrollToPositionFixed} from "../../utils/ScrollToPositionFixed";
import device from "current-device";

const Header = ({LanguageFalse}) => {
    const {t} = useTranslation();
    const size = useWindowSize();
    const [top, setTop] = useState('0px');
    const [mobileMenu, setMobileMenu] = useContext(MobileMenuContext);

    useEffect(() => {
        const headerHidden = () => {
            document.querySelector('.footer')
                ? setTop((window.innerHeight * 2 < document.body.offsetHeight) && (window.scrollY + window.innerHeight > document.body.offsetHeight - document.querySelector('.footer').offsetHeight) ? '-100px' : '0px')
                : setTop('0px');
        };
        document.addEventListener('scroll', headerHidden);

        return () => {
            document.removeEventListener('scroll', headerHidden);
        }
    }, [size]); // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (!e.target.closest('.mobile_menu') && !e.target.closest('.mobile_click')) {
                ScrollToPositionFixed(true);
                setMobileMenu(false);
            }
        };
        if (mobileMenu) {
            document.addEventListener("click", checkIfClickedOutside);
        }
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [mobileMenu]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {mobileMenu ? <div className={`mobile_menu ${mobileMenu ? 'open' : ''}`}>
                <div className="content" style={{display: mobileMenu ? 'block' : 'none'}}>
                    <Menu separator={true} />
                    <div className="bottom">
                        <span>{new Date().getFullYear()} © ChampionTM{device.desktop() ? `. ${t('Всі права захищені.')}` : ''}</span>
                    </div>
                </div>
            </div> : null}
            <header
                className={`header ${mobileMenu ? 'open' : ''}`}
                style={{top: top}}
            >
                <div className="row">
                    <div className="left_block">
                        {device.desktop()
                            ? <button
                                type="button"
                                className={`mobile_click ${mobileMenu ? 'open' : 'close'}`}
                                onClick={() => {
                                    if (mobileMenu) {
                                        ScrollToPositionFixed(true);
                                        setMobileMenu(false);
                                    } else {
                                        setMobileMenu(!mobileMenu);
                                        ScrollToPositionFixed(false, window.pageYOffset);
                                    }
                                }} />
                            : <NavLink className='logo' to={GenerateURL(INDEX_ROUTE)}>
                                <img src={logo} alt="logo"/>
                            </NavLink>
                        }
                    </div>
                    {device.desktop() ? <div className="center_block">
                        <NavLink
                            className='logo'
                            to={GenerateURL(INDEX_ROUTE)}
                        ><img src={logo} alt="logo"/>
                        </NavLink>
                    </div> : null}
                    <div className="right_block">
                        <div className="right_block_content">
                            {!device.desktop() ? <button
                                type="button"
                                className={`mobile_click ${mobileMenu ? 'open' : 'close'}`}
                                onClick={() => {
                                    if (mobileMenu) {
                                        ScrollToPositionFixed(true);
                                        setMobileMenu(false);
                                    } else {
                                        setMobileMenu(!mobileMenu);
                                        ScrollToPositionFixed(false, window.pageYOffset);
                                    }
                                }} /> : null}

                            {device.desktop()
                                ? !LanguageFalse ? <Language setMobileMenu={setMobileMenu} /> : null
                                : <div
                                    className={`mobile_menu ${mobileMenu ? 'open' : ''}`}
                                >
                                    <div className="logo">
                                        <NavLink
                                            to={GenerateURL(INDEX_ROUTE)}
                                            onClick={() => {
                                                ScrollToPositionFixed(true);
                                                setMobileMenu(false);
                                            }}
                                        ><img src={logo} alt="logo"/>
                                        </NavLink>
                                    </div>
                                    <div className="content">
                                        <Menu separator={false} />
                                        {!LanguageFalse ? <Language setMobileMenu={setMobileMenu} /> : null}
                                        <div className="bottom">
                                            <span>{`${new Date().getFullYear()} © ChampionTM`}</span>
                                        </div>
                                    </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default observer(Header);